import {Component, Inject, Input, PLATFORM_ID, ViewChild} from '@angular/core';
import {AuthHeaderComponent} from "../auth-header/auth-header.component";
import {GuestHeaderComponent} from "../guest-header/guest-header.component";
import {DOCUMENT, isPlatformBrowser, NgClass, NgIf, NgOptimizedImage} from "@angular/common";
import {ServicesDropdownComponent} from "../../../dropdowns/services-dropdown/services-dropdown.component";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import { Router, RouterLink, RouterLinkActive} from "@angular/router";
import {SafePipe} from "@cybfed/shared/pipes/safe.pipe";
import {SideBarComponent} from "@cybfed/ui-lib/side-bar/side-bar.component";
import {StorageService} from "@cybfed/core/services/storage.service";
import {AddNewDropdownComponent} from "@cybfed/new-ui/components/dropdowns/add-new-dropdown/add-new-dropdown.component";
import {LanguageChangerComponent} from "@cybfed/shared/components/language-changer/language-changer.component";
import {MessagesDropdownComponent} from "@cybfed/new-ui/components/dropdowns/messages-dropdown/messages-dropdown.component";
import {NotificationDropdownComponent} from "@cybfed/new-ui/components/dropdowns/notifications-dropdown/notification-dropdown.component";
import {ProfileDropdownComponent} from "../../../dropdowns/profile-dropdown/profile-dropdown.component";
import {AuthenticationService} from "@cybfed/core/services/authentication.service";
import {EventManagerService} from "@cybfed/core/services/event-manager.service";
import {SocketConnect} from "@cybfed/core/services/socket/socket-connect";
import {WindowRef} from "ngx-stripe";
import {customSetInterval} from "@cybfed/core/helpers/overrided-timers";
import {
    ProfileDropdownSubdomainComponent
} from "../../../dropdowns/profile-dropdown-subdomain/profile-dropdown-subdomain.component";

@Component({
  selector: 'app-subdomain-logged-in-header',
  standalone: true,
    imports: [
        AuthHeaderComponent,
        GuestHeaderComponent,
        NgOptimizedImage,
        ServicesDropdownComponent,
        TranslateModule,
        RouterLink,
        RouterLinkActive,
        SafePipe,
        SideBarComponent,
        NgClass,
        AddNewDropdownComponent,
        LanguageChangerComponent,
        MessagesDropdownComponent,
        NgIf,
        NotificationDropdownComponent,
        ProfileDropdownComponent,
        ProfileDropdownSubdomainComponent
    ],
  providers: [
      AuthenticationService,
      WindowRef,
  ],
  templateUrl: './subdomain-logged-in-header.component.html',
  styleUrl: './subdomain-logged-in-header.component.scss'
})
export class SubdomainLoggedInHeaderComponent {

    @Input() authUser: any;
    @Input() giftCount = 0;
    @Input() forMobile : boolean = false;
    @ViewChild('modalUsers') modalUsers: any;
    @ViewChild('modal') modal: any;
    type = 'signin';
    showMenu = false;
    showMobileMenu = false;
    activeWidgetIndex = -1;
    errorMessage: any;
    nickname: any;
    balance: number = 0;
    tickets: number = 0;

    soundEnabled = (StorageService.getItem(StorageService.statics.soundEnabled)  == 'true');
    currency: any;
    showMyPublishersHref: boolean = false
    navigateObj: any;
    avatarUrl: any;

    @ViewChild('sliderSideMenu') sliderSideMenu: any;
    public publishers: any;
    public pubBool: boolean = false;

    constructor(private router: Router,
                private authenticationService: AuthenticationService,
                private eventManagerService: EventManagerService,
                private socketComponent: SocketConnect,
                @Inject(PLATFORM_ID) private platformId: any,
                @Inject(DOCUMENT) private dom,
                private windowRef: WindowRef,
    ) {
    }

    ngOnInit(): void {
        this.eventManagerService.menuTrigger.subscribe((data) => {
            this.pubBool = false
            this.activeWidgetIndex = data
            if(this.activeWidgetIndex === -2){
                this.onClose();
            }
        });
        this.eventManagerService.profileDataSatedEmitter.subscribe(() => {
            let user = StorageService.getJsonItem(StorageService.statics.profileData) ? StorageService.getJsonItem(StorageService.statics.profileData) : {}
            this.avatarUrl = {avatarUrl: user.avatarUrl, nickname: user.nickname};
            if(user.publishers && user.publishers.length){
                this.showMyPublishersHref = true
            }
        })
        this.eventManagerService.showRegisterModal.subscribe(() => {
            this.openModal('signup')
        })
        this.eventManagerService.showLoginModal.subscribe(() => {
            this.openModal('signin')
        })
        this.eventManagerService.changeUserEmitter.subscribe((data) => {
            let user = StorageService.getJsonItem(StorageService.statics.profileData) ? StorageService.getJsonItem(StorageService.statics.profileData) : {}
            if (data.nickname) {
                if(user.nickname !== data.nickname && !user.avatarUrl){
                    this.avatarUrl = {avatarUrl: user.avatarUrl, nickname: user.nickname};
                    user.avatarUrl = data.avatarUrl
                }
                user.nickname = data.nickname
                this.nickname =  data.nickname
            }
            if (data.currency) {
                user.currency = data.currency
                this.currency = data.currency
            }
            if (data.balance) {
                user.balance = data.balance
                this.balance = data.balance
            }
            if (data.tickets) {
                user.tickets = data.tickets
                this.tickets = data.tickets
                let currentAction = StorageService.getJsonItem(StorageService.statics.lastAction);
                if(currentAction === 'join'){
                    this.eventManagerService.participateService.emit()
                }
            }
            if (data.avatarUrl !== undefined) {
                this.avatarUrl = {avatarUrl: data.avatarUrl, nickname: user.nickname};
                user.avatarUrl = data.avatarUrl
            }
            if (data.location) {
                user.location = data.location
            }
            if (data.city) {
                user.city = data.city
            }
            if (data.address1) {
                user.address1 = data.address1
            }
            if (data.address2) {
                user.address2 = data.address2
            }
            if (data.status) {
                user.status = data.status
            }
            if (data.hasPassword !== undefined) {
                user.hasPassword = data.hasPassword
            }
            StorageService.setJsonItem(StorageService.statics.profileData, user)
        })

    }

    onOpenWidget(): void {
        this.eventManagerService.menuTrigger.emit(1);
    }


    onClose(): void {
        this.pubBool = false
        this.eventManagerService.menuTrigger.emit(-1);
        this.showMenu = false;
        this.showMobileMenu = false;
        this.dom.body.setAttribute('style', 'overflow-y:auto');
    }


    openCloseMobileMenu(): void {
        this.showMobileMenu = !this.showMobileMenu;
        if (this.showMobileMenu) {
            this.dom.body.setAttribute('style', 'overflow-y:hidden');
        } else {
            this.dom.body.setAttribute('style', 'overflow-y:auto');
        }
    }

    async logOut() {
        this.onClose();
        let lang = StorageService.getItem(StorageService.statics.lang)
        let currency = StorageService.getItem(StorageService.statics.currency)
        // this.router.navigate(['/auth/signin'])
        this.authenticationService.logout().subscribe((data: any) => {
            StorageService.clear()
            let interval = customSetInterval(() =>{
                if(!StorageService.getToken()){
                    clearInterval(interval);
                    StorageService.setItem(StorageService.statics.lang, lang);
                    StorageService.setItem(StorageService.statics.currency, currency);
                    this.socketComponent.disconnect();
                    this.router.navigate(['/']).then(()=>{
                        if(isPlatformBrowser(this.platformId)) {
                            (this.windowRef as any).nativeWindow.location.reload();
                        }
                    });
                }
            },10);
        })

    }

    onNavigate(): void {
        this.router.navigate([this.navigateObj.url])
    }

    openModal(type: string){
        if(type === 'signin'){
            this.type = 'signin'
        } else {
            this.type = 'signup'
        }
        this.modal.show();
    }
    changeModalTub(type: any){
        if(type === 'signin'){
            this.type = 'signin'
        } else {
            this.type = 'signup'
        }
    }

    myProfil() {
        this.router.navigate(['player/'+ this.authUser.userId]).then(()=>{
            this.onClose()
        });
    }

    toggleSound() {
        this.soundEnabled = !this.soundEnabled;
        StorageService.setItem(StorageService.statics.soundEnabled, this.soundEnabled);
        this.onClose();
    }
    getClans() {
        this.pubBool = true
    }

    changePubSection(event:boolean) {
        this.pubBool = event;
    }

    closeWidg(event: any) {
        this.onOpenWidget()
    }

    navigateToPublisher(event: any) {
        this.eventManagerService.showPublisherToAccountLoading({avatar:event.avatarUrl, nickname:event.name})
        this.router.navigate(['/publisher/' + event._id + '/dashboard'])
    }
}


